module.exports={
	"Form": "AssetTypeCreateManifest",
	"Scope": "AssetType-Create",
	"Descriptors":
	{
		"AssetTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetType-Create-Identity",
				"Group": "AssetType-Create-Identity"
			}
		},
		"AssetTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetType-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetType-Create-Details",
				"Group": "AssetType-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
